import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import {
  dateTimeReportFormatter,
  durationReportFormatter,
} from "../../fomatters/DateFormatter";
import InputSelect from "../InputSelect";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

const startDateValue = currentDate.toISOString().split("T")[0];
const endDateValue = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function CallsLog() {
  const [startDate, setStartDate] = useState(startDateValue);
  const onStartDateChange = useCallback(
    (event) => setStartDate(event.target.value),
    []
  );

  const [endDate, setEndDate] = useState(endDateValue);
  const onEndDateChange = useCallback(
    (event) => setEndDate(event.target.value),
    []
  );

  const [player, setPlayer] = useState("");
  const onPlayerChanged = useCallback(
    (event) => setPlayer(event.target.value),
    []
  );

  const [agent, setAgent] = useState("");
  const onAgentChanged = useCallback(
    (event) => setAgent(event.target.value),
    []
  );

  const [phoneLine, setPhoneLine] = useState("");
  const onPhoneLineChanged = useCallback(
    (event) => setPhoneLine(event.target.value),
    []
  );

  const [selection, setSelection] = useState(0);
  const onSelectionChange = useCallback(
    (event) => setSelection(Number(event.target.value)),
    []
  );

  const [book, setBook] = useState("");
  const onBookChanged = useCallback((b) => setBook(b), []);
  const { values: books } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/Player/GetBooks`,
  });

  const [group, setGroup] = useState("");
  const onGroupChanged = useCallback((g) => setGroup(g), []);
  const { values: groups } = useDataFormatterHook({
    addEmpty: true,
    value: "groupName",
    text: "groupName",
    path: `/Player/Grouping_GetList`,
  });

  const [lineType, setLineType] = useState("");
  const onLineTypeChanged = useCallback((l) => setLineType(l), []);
  const { values: lineTypes } = useDataFormatterHook({
    addEmpty: true,
    value: "description",
    text: "description",
    path: `/LineType/GetLineTypes`,
  });

  const [user, setUser] = useState("");
  const onUserChange = useCallback((u) => setUser(u), []);
  const { values: users } = useDataFormatterHook({
    addEmpty: true,
    value: "loginName",
    text: "loginName",
    path: `/User/GetUsers`,
  });

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          className="flex-1"
          required
          variant="outlined"
          id="gameDateTime"
          label="From"
          type="date"
          value={startDate}
          size="small"
          onChange={onStartDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          id="gameDateTime"
          label="To"
          type="date"
          value={endDate}
          size="small"
          onChange={onEndDateChange}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Book"
          name="name"
          data={books}
          placeholder="DataFormatter"
          setSelectValue={onBookChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Player"
          type="text"
          value={player}
          size="small"
          onChange={onPlayerChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Group"
          name="name"
          data={groups}
          placeholder="DataFormatter"
          setSelectValue={onGroupChanged}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Agent"
          type="text"
          value={agent}
          size="small"
          onChange={onAgentChanged}
          InputLabelProps={{ shrink: true }}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="Line Type"
          name="name"
          data={lineTypes}
          placeholder="DataFormatter"
          setSelectValue={onLineTypeChanged}
          startValue={""}
        />
        <InputSelect
          variant="outlined"
          size="small"
          label="User"
          name="name"
          data={users}
          placeholder="DataFormatter"
          setSelectValue={onUserChange}
          startValue={""}
        />
        <TextField
          required
          variant="outlined"
          label="Station"
          type="text"
          value={phoneLine}
          size="small"
          onChange={onPhoneLineChanged}
          InputLabelProps={{ shrink: true }}
        />
        <div>
          <SubGroup title="Select Only">
            <FormControl component="fieldset">
              <RadioGroup
                label
                value={selection}
                onChange={onSelectionChange}
                row
              >
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="All"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Phone"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="OnLine"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Calls Log Report"
        onRowClick={(...args) => console.log(args)}
        getUrl={() => "/Reports/Report_Call_Log_2"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          StartDate: startDate,
          EndDate: endDate,
          Book: book,
          Player: player,
          Group: group,
          Agent: agent,
          LineType: lineType,
          User: user,
          PhoneLine: phoneLine,
          Selection: selection,
        })}
        getTotals={(data) => ({
          player: "",
          phoneLine: "Calls",
          loginname: data.length,
          startTime: "",
          endTime: "Totals",
          duration: data.reduce((acc, item) => acc + item.duration, 0),
          betstaked: data.reduce((acc, item) => acc + item.betstaked, 0),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="player">
          Player
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="phoneLine">
          Station
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="loginname">
          User
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="startTime"
          dataFormat={dateTimeReportFormatter}
        >
          In
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="endTime"
          dataFormat={dateTimeReportFormatter}
        >
          Out
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="duration"
          dataFormat={durationReportFormatter}
        >
          Time
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="betstaked">
          Wagers
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agent">
          Agent
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default CallsLog;
